/**
 * Vòng đời khuôn / bản in (enum ToolingStatus) — một nguồn cho máy chủ (chặn chuyển sai) và màn hình
 * (chỉ hiện nút / lựa chọn hợp lệ, FB-CKDM1P). Đã thanh lý / Đã huỷ là trạng thái cuối;
 * Hỏng chỉ đi bảo dưỡng hoặc thanh lý (không quay thẳng về Sẵn sàng).
 */
export const TOOLING_STATUS_TRANSITIONS: Record<string, string[]> = {
  PENDING: ['AVAILABLE', 'CANCELLED'],
  AVAILABLE: ['IN_USE', 'MAINTENANCE', 'DAMAGED', 'DISCARDED'],
  IN_USE: ['AVAILABLE', 'MAINTENANCE', 'DAMAGED'],
  MAINTENANCE: ['AVAILABLE', 'DAMAGED', 'DISCARDED'],
  DAMAGED: ['MAINTENANCE', 'DISCARDED'],
  DISCARDED: [],
  CANCELLED: [],
};

export const TOOLING_STATUS_LABEL: Record<string, string> = {
  PENDING: 'Chờ làm / chờ nhận',
  AVAILABLE: 'Sẵn sàng',
  IN_USE: 'Đang gá / lắp trên máy',
  MAINTENANCE: 'Đang bảo dưỡng',
  DAMAGED: 'Hỏng',
  DISCARDED: 'Đã thanh lý',
  CANCELLED: 'Đã huỷ',
};

/** Trạng thái được phép chuyển tới từ `from` (không gồm chính nó) */
export function nextToolingStatuses(from: string | null | undefined): string[] {
  return TOOLING_STATUS_TRANSITIONS[String(from || '')] || [];
}

/** Giữ nguyên trạng thái hiện tại luôn hợp lệ; còn lại theo bảng vòng đời */
export function canToolingTransition(from: string | null | undefined, to: string | null | undefined): boolean {
  if (!to || from === to) return true;
  return nextToolingStatuses(from).includes(String(to));
}
